export default __webpack_public_path__ + "static/media/Place_card.b044205a.png";